import React from 'react'
import { UIUser, UserRole } from 'types';
import { Button, Checkbox, Label, Modal, Spinner } from 'flowbite-react';
import { useToast } from 'src/context/ToastProvider';
import { useMutation } from 'react-query';
import { updateCredentials } from 'src/apis/user';
import { get } from 'lodash';
interface Props {
    user?: UIUser;
    openModifyNumberModal: boolean;
    setOpenModifyNumberModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModifyNumberModal = ({ user, openModifyNumberModal, setOpenModifyNumberModal }: Props) => {
    const toast = useToast();
    const [updatedPhoneNumber, setUpdatedPhoneNumber] = React.useState<string>('');
    const [showError, setShowError] = React.useState<string>("");

    const modifyPhoneNumber = useMutation(['modifyPhoneNumber'], updateCredentials, {
        onSuccess(data) {
            toast({
                title: data.message || '',
                type: 'success',
            });
            setShowError("");
            setOpenModifyNumberModal(false);
        },
        onError(error: Error) {
            const errorMessage = get(error, ['response', 'data', 'message'], error.message);
            setShowError(errorMessage);
        },
    });
    return (
        <Modal show={openModifyNumberModal} size="xl" onClose={() => setOpenModifyNumberModal(false)} dismissible>
            <Modal.Header>
                <h1 className="text-[#1C1C28] dark:text-inherit text-2xl font-inter font-[500]">
                    Update Phone Number for <span className="text-xl text-green-500 font-500">{user?.email}</span>{' '}
                </h1>
            </Modal.Header>
            <Modal.Body>
                <div className="flex flex-col gap-4">
                    <div className="flex items-center gap-4">
                        <Label htmlFor="existingPhone" className="text-[#7777E7] w-48">Existing Phone Number :</Label>
                        <input 
                            type="text" 
                            id="existingPhone" 
                            value={user?.phone} 
                            disabled 
                            className="cursor-not-allowed bg-gray-200 rounded-md border-gray-300 flex-1"
                        />
                    </div>
                    <div className="flex items-center gap-4">
                        <Label htmlFor="newPhone" className="text-[#7777E7] w-48">New Phone Number :</Label>
                        <input 
                            type="text" 
                            id="newPhone" 
                            value={updatedPhoneNumber}
                            className="rounded-md border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 flex-1"
                            onChange={(e) => setUpdatedPhoneNumber(e.target.value)}
                        />
                    </div>
                </div>
                <div className="flex justify-center mt-8">
                    <Button
                        disabled={!updatedPhoneNumber || updatedPhoneNumber.length < 10}
                        onClick={() => {
                            modifyPhoneNumber.mutate({
                               email: user?.email || '',
                               phone: updatedPhoneNumber,
                            });
                        }}
                    >
                        Update
                    </Button>
                </div>
                {showError && (
                    <div className="mt-4 text-red-500">
                        {showError}
                    </div>
                )}
            </Modal.Body>
        </Modal>

    )
}

export default ModifyNumberModal

